<template>
  <v-data-table
      dense
      :headers="headers"
      :items="DRIVER_PAYIN"
      :hide-default-footer="true"
      class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Driver Pay-In Percentage</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical>
          </v-divider>
          <v-spacer></v-spacer>
          <v-dialog
            max-width="600"
            v-model="dialog">
            <template v-slot:activator="{ on, attrs }">
              <v-select
                @change="newDriverPayIn()"
                :items="DRIVERS"
                v-model="selectedDriver"
                :item-text="item => `${item.givenName},
                      ${item.familyName}`"
                item-value="id"
                label="Add new pay-in"
                return-object
                dense>
              </v-select>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <ValidationObserver ref="driverPayIn" v-slot="{ invalid, valid, errors }">
                  <v-form v-model="driverPayInValid">
                    For driver: {{ editedItem.givenName }} {{ editedItem.familyName }}
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <ValidationProvider
                                rules="required|min_value:1|max_value:100"
                                name="PayInPercentage"
                                vid="payInPercentage"
                                v-slot="{ errors }">
                                <v-currency-field
                                  :error-messages="errors"
                                  label="Pay-in %"
                                  v-model="editedItem.payInPercentage"
                                  suffix="%"
                                  type="number"
                                  money="money"
                                  maxlength="6">
                                </v-currency-field>
                              </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-menu
                            v-model="menu1"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px">
                            <template v-slot:activator="{ on }">
                              <validation-provider
                                name="From date"
                                :rules="'required'"
                                v-slot="{errors}" slim>
                                <v-text-field
                                  :value="fmtFromDate"
                                  label="From date"
                                  append-icon="mdi-calendar"
                                  readonly
                                  :error-messages="errors"
                                  v-on="on"
                                  @click:clear="editedItem.fromDate = null">
                                </v-text-field>
                              </validation-provider>
                            </template>
                            <v-date-picker
                              v-model="editedItem.fromDate"
                              @input="menu1 = false">
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px">
                            <template v-slot:activator="{ on }">
                              <validation-provider
                                name="To date"
                                v-slot="{errors}" slim>
                                <v-text-field
                                  :value="fmtToDate"
                                  label="To date"
                                  append-icon="mdi-calendar"
                                  readonly
                                  :error-messages="errors"
                                  clearable
                                  v-on="on"
                                  @click:clear="editedItem.toDate = null">>
                                </v-text-field>
                              </validation-provider>
                            </template>
                            <v-date-picker
                              v-model="editedItem.toDate"
                              @input="menu2 = false">
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </ValidationObserver>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="close">
                  Cancel
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="saveDriver">
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title>
                Are you sure you want to delete this item?
              </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="deleteConfirm">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editDriver(item)">
          mdi-pencil
        </v-icon>
        <v-icon
          v-if="IS_ADMINISTRATOR"
          small
          class="mr-2"
          @click="deleteDriverPayIn(item)">
          mdi-eraser
        </v-icon>
      </template>
      <template v-slot:item.givenName="{ item }">
        {{ item.givenName }}
      </template>
      <template v-slot:item.familyName="{ item }">
        {{ item.familyName }}
      </template>
      <template v-slot:item.rawPayInPercentage="{ item }">
        {{ item.rawPayInPercentage | toPercentage(2, false)}}
      </template>
      <template v-slot:item.fromDate="{ item }">
        {{ $moment(item.fromDate).format(DISPLAY_DATE_FORMAT) }}
      </template>
      <template v-slot:item.toDate="{ item }">
        {{ $moment(item.toDate).isValid()
          ? $moment(item.toDate).format(DISPLAY_DATE_FORMAT) : '-' }}
      </template>
  </v-data-table>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { mask } from 'vue-the-mask';
/* eslint-disable camelcase */
import { required, min_value, max_value } from 'vee-validate/dist/rules';
/* eslint-enable camelcase */
import
{
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';
import storeConstants from '@/store/storeConstants';

setInteractionMode('eager');

extend('required', required);
extend('min_value', min_value);
extend('max_value', max_value);

export default {
  name: 'DriverPayIn',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  mounted() {
    if (this.IS_ADMINISTRATOR) {
      this.GET_DRIVER_PAYIN();
    }
  },
  data: () => ({
    menu2: false,
    menu1: false,
    editedIndex: undefined,
    editedItem: undefined,
    deleteItem: undefined,
    dialog: false,
    dialogDelete: false,
    selectedDriver: undefined,
    driverPayInValid: false,
    headers: [
      { text: 'Actions', value: 'actions', sortable: false },
      { text: 'Given Name', value: 'givenName' },
      { text: 'Family Name', value: 'familyName' },
      { text: 'Payin percentage', value: 'rawPayInPercentage' },
      { text: 'FromDate', value: 'fromDate' },
      { text: 'ToDate', value: 'toDate' },
    ],
  }),
  directives: {
    mask,
  },
  computed: {
    ...mapGetters([
      storeConstants.DRIVERS,
      storeConstants.DRIVER_PAYIN,
      storeConstants.DISPLAY_DATE_FORMAT,
      storeConstants.ISO_8601_FORMAT,
      storeConstants.IS_ADMINISTRATOR,
      storeConstants.IS_DRIVER,
    ]),
    formTitle() {
      return this.editedIndex === -1 ? 'New Driver Payin' : 'Edit Driver Payin';
    },
    fmtToDate() {
      if (!this.editedItem.toDate) {
        return null;
      }
      return this
        .$moment(this.editedItem.toDate)
        .format(this.DISPLAY_DATE_FORMAT);
    },
    fmtFromDate() {
      if (!this.editedItem.fromDate) {
        return null;
      }
      return this
        .$moment(this.editedItem.fromDate)
        .format(this.DISPLAY_DATE_FORMAT);
    },
  },
  methods: {
    ...mapActions([storeConstants.GET_DRIVER_PAYIN,
      storeConstants.SAVE_DRIVER_PAYIN,
      storeConstants.DELETE_DRIVER_PAYIN,
    ]),
    editDriver(item) {
      this.editedIndex = this.DRIVER_PAYIN.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    newDriverPayIn() {
      this.editedItem = {
        id: null,
        userId: this.selectedDriver.id,
        givenName: this.selectedDriver.givenName,
        familyName: this.selectedDriver.familyName,
        payInPercentage: null,
        fromDate: null,
        toDate: null,
      };
      this.editedIndex = -1;
      this.dialog = true;
      this.selectedDriver = {};
      return null;
    },
    saveDriver() {
      this.$refs.driverPayIn.validate().then((success) => {
        this.driverPayInValid = success;
        if (this.driverPayInValid) {
          this.SAVE_DRIVER_PAYIN(this.editedItem)
            .then(() => {
              this.dialog = false;
              this.selectedDriver = {};
              this.editedItem = {};
            },
            (error) => {
              this.SET_ALERT_DETAILS({ alertText: error.response.data.error, showAlert: true });
              this.isLoading = false;
            })
            .catch(() => {
              this.isLoading = false;
            });
        }
      });
    },
    close() {
      this.dialog = false;
    },
    closeDelete() {
      this.deleteItem = null;
      this.dialogDelete = false;
    },
    deleteDriverPayIn(item) {
      this.deleteItem = item;
      this.dialogDelete = true;
    },
    deleteConfirm() {
      this.DELETE_DRIVER_PAYIN(this.deleteItem.id)
        .then(() => {
          this.deleteItem = null;
          this.dialogDelete = false;
        },
        (error) => {
          this.SET_ALERT_DETAILS({ alertText: error.response.data.error, showAlert: true });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
      this.dialogDelete = false;
    },
  },
};
</script>
